import React, { useState } from 'react';
import { useContent } from '../i18n/LanguageContext';
import { Quote, ArrowRight, CheckCircle2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';

export default function CaseStudies() {
  const c = useContent();
  const cs = c.caseStudies;
  const [selected, setSelected] = useState(null);
  const item = selected !== null ? cs.items[selected] : null;
  const dt = cs.detail;
  return (
    <section id="cas-clients" className="py-14 md:py-20 bg-white">
      <div className="lt-container">
        <div className="max-w-3xl reveal">
          <p className="text-sm font-semibold uppercase tracking-widest text-teal-600">{cs.eyebrow}</p>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-slate-900 leading-tight">{cs.title}</h2>
          <p className="mt-4 text-lg text-slate-600">{cs.subtitle}</p>
          <p className="mt-3 text-sm text-slate-400 italic">{cs.note}</p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {cs.items.map((it, i) => (
            <button key={i} onClick={() => setSelected(i)} className="reveal card-hover group text-left relative rounded-2xl border border-slate-200 bg-white p-7 flex flex-col" style={{ animationDelay: `${i * 90}ms` }}>
              <Quote className="w-8 h-8 text-teal-200" />
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-display text-4xl font-bold text-gradient">{it.metric}</span>
                <span className="text-sm text-slate-500">{it.metricLabel}</span>
              </div>
              <p className="mt-4 text-slate-700 leading-relaxed flex-1">“{it.quote}”</p>
              <div className="mt-6 pt-4 border-t border-slate-100">
                <p className="font-semibold text-slate-900">{it.author}</p>
                <p className="text-sm text-slate-500">{it.company}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-teal-600 group-hover:gap-2 transition-all">
                  {dt.cta}<ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>

      <Dialog open={selected !== null} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent className="max-w-lg bg-white text-slate-900">
          {item && (
            <>
              <DialogHeader>
                <span className="inline-block w-fit text-xs font-bold text-teal-700 bg-teal-50 rounded-full px-3 py-1">{item.sector}</span>
                <DialogTitle className="mt-2 font-display text-xl">{item.company}</DialogTitle>
              </DialogHeader>
              <div className="flex items-baseline gap-2">
                <span className="font-display text-3xl font-bold text-gradient">{item.metric}</span>
                <span className="text-sm text-slate-500">{item.metricLabel}</span>
              </div>
              <div className="mt-2 space-y-4 text-sm">
                <div>
                  <p className="text-xs uppercase tracking-wide text-slate-400 font-semibold">{dt.context}</p>
                  <p className="mt-1 text-slate-600 leading-relaxed">{item.context}</p>
                </div>
                <div>
                  <p className="text-xs uppercase tracking-wide text-slate-400 font-semibold">{dt.solution}</p>
                  <p className="mt-1 text-slate-600 leading-relaxed">{item.solution}</p>
                </div>
                <div>
                  <p className="text-xs uppercase tracking-wide text-slate-400 font-semibold">{dt.results}</p>
                  <ul className="mt-2 space-y-1.5">
                    {item.results.map((r) => (
                      <li key={r} className="flex items-start gap-2 text-slate-700">
                        <CheckCircle2 className="w-4 h-4 text-teal-600 mt-0.5 shrink-0" />{r}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <p className="mt-4 rounded-xl bg-slate-50 border border-slate-200 p-3 text-slate-600 text-sm italic">“{item.quote}” — {item.author}</p>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
